// @ts-nocheck
import {createContext,useContext} from "react";

export const BodyContext = createContext({});
export function useBody() {
    return useContext(BodyContext);
}
